<script>
export default {
  props: {
    titleSteps: {
      typeof: String,
      required: true
    },
    IndexStep: {
      typeof: Number,
      default: 0
    },
    namesSteps: {
      typeof: Array,
      default: ['Step 1', 'Step 2', 'Step 3']
    }
  }
}
</script>

<template>
  <div id="stepForms">
    <h3 class="text-center">{{ titleSteps }}</h3>
    <el-steps :active="IndexStep" finish-status="success">
      <el-step v-for="(name, index) in namesSteps" :title="name" :key="index"></el-step>
    </el-steps>
  </div>
</template>

<style lang="scss" scoped>
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Steps/Steps.vue